import type { ValueOf } from '@shared/types/utilities';
import { FIELD_TYPES } from '@shared/types/field';
import {
  Calendar,
  Call,
  Flag,
  I24Support,
  Text,
  TextBlock,
  TickCircle,
  TickSquare,
} from 'iconsax-react';
import { List } from 'lucide-react';

type ColumnType = ValueOf<typeof FIELD_TYPES>;

export interface ColumnTypeOption {
  label: string;
  value: ValueOf<typeof FIELD_TYPES>;
  icon: React.ComponentType<{ className?: string }>;
}

/**
 * Column type options for custom fields
 * Maps to FIELD_TYPES from shared/types/field.ts
 */
export const COLUMN_TYPES: ColumnTypeOption[] = [
  {
    label: 'Short Text',
    value: FIELD_TYPES.shortAnswer,
    icon: TextBlock,
  },
  {
    label: 'Long Text',
    value: FIELD_TYPES.paragraph,
    icon: Text,
  },
  {
    label: 'Single Selection',
    value: FIELD_TYPES.ratio,
    icon: TickCircle,
  },
  {
    label: 'Multiple Selection',
    value: FIELD_TYPES.checklist,
    icon: TickSquare,
  },
  {
    label: 'Numbers',
    value: FIELD_TYPES.number,
    icon: I24Support,
  },
  {
    label: 'Phone',
    value: FIELD_TYPES.phoneNumber,
    icon: Call,
  },
  {
    label: 'Date',
    value: FIELD_TYPES.date,
    icon: Calendar,
  },
  {
    label: 'Country',
    value: FIELD_TYPES.country,
    icon: Flag,
  },
  // {
  //   label: 'Email',
  //   value: FIELD_TYPES.email,
  //   icon: EmailIcon,
  // },
  {
    label: 'Dropdown',
    value: FIELD_TYPES.dropdown,
    icon: List,
  },
];

export const getCustomFieldColumnByType = (type: ColumnType) => {
  return COLUMN_TYPES.find((column) => column.value === type);
};
